import { render, staticRenderFns } from "./PasswordModification.vue?vue&type=template&id=dfbb43ea&scoped=true"
import script from "./PasswordModification.vue?vue&type=script&lang=js"
export * from "./PasswordModification.vue?vue&type=script&lang=js"
import style0 from "./PasswordModification.vue?vue&type=style&index=0&id=dfbb43ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbb43ea",
  null
  
)

export default component.exports